export const DIGITAL_PRIVATE_INFRASTUCTURE_RESET_STATE = 'DIGITAL_PRIVATE_INFRASTUCTURE_RESET_STATE';
export const DIGITAL_PRIVATE_INFRASTUCTURE_CURRENT_ITEM = 'DIGITAL_PRIVATE_INFRASTUCTURE_CURRENT_ITEM';

export const DIGITAL_PRIVATE_INFRASTUCTURE_REQUEST_LOADING = 'DIGITAL_PRIVATE_INFRASTUCTURE_REQUEST_LOADING';
export const DIGITAL_PRIVATE_INFRASTUCTURE_REQUEST_SUCCESS = 'DIGITAL_PRIVATE_INFRASTUCTURE_REQUEST_SUCCESS';
export const DIGITAL_PRIVATE_INFRASTUCTURE_REQUEST_FAILED = 'DIGITAL_PRIVATE_INFRASTUCTURE_REQUEST_FAILED';

export const DIGITAL_PRIVATE_INFRASTUCTURE_CURRENT_ACTION = 'DIGITAL_PRIVATE_INFRASTUCTURE_CURRENT_ACTION';
export const DIGITAL_PRIVATE_INFRASTUCTURE_RESET_ACTION = 'DIGITAL_PRIVATE_INFRASTUCTURE_RESET_ACTION';